import i18n from 'invision-core/src/components/i18n/i18n';
import CustomerCareKeys from '../../../../../../../locales/keys';
import { SERVICE_FEATURE_ORDER_WIZARD_MODE } from '../../../../../../../reducers/constants/products.wizard.constants';
export var isServiceFeatureOrder = function isServiceFeatureOrder(routeParams) {
  return (routeParams.service || routeParams.serviceId) && routeParams.mode === SERVICE_FEATURE_ORDER_WIZARD_MODE.MANAGE;
};
export var setProductListItemSelected = function setProductListItemSelected(shoppingCart, products) {
  if (shoppingCart.Items && shoppingCart.Items.length) {
    shoppingCart.Items.forEach(function (item) {
      var selectedProduct = products.find(function (product) {
        return product.Id === item.ProductId;
      });
      if (selectedProduct) {
        //null check needed due to search clearing out product that was already selected
        selectedProduct.isSelected = true;
      }
    });
  }
};
export var getButtonCount = function getButtonCount(shoppingCart, products) {
  if (shoppingCart.Items && shoppingCart.Items.length) {
    shoppingCart.Items.forEach(function (item) {
      var selectedProduct = products.find(function (product) {
        return product.Id === item.ProductId;
      });
      if (selectedProduct) {
        //null check needed due to search clearing out product that was already selected
        selectedProduct.buttonCount += item.Quantity;
        selectedProduct.selectedText = i18n.translate(CustomerCareKeys.EDIT_OPTIONS, {
          count: selectedProduct.buttonCount
        });
      }
    });
  }
};
export var setPricingPlanQuantities = function setPricingPlanQuantities(shoppingCart, products) {
  if (shoppingCart.Items && shoppingCart.Items.length) {
    shoppingCart.Items.forEach(function (item) {
      var selectedProduct = products.find(function (product) {
        return product.Id === item.ProductId;
      });
      var selectedPricingPlan = selectedProduct && selectedProduct.ProductContext && selectedProduct.ProductContext.OrderablePricingPlans && selectedProduct.ProductContext.OrderablePricingPlans.length ? selectedProduct.ProductContext.OrderablePricingPlans.find(function (pricingPlan) {
        return pricingPlan.Id === item.PricingPlanId;
      }) : null;
      if (selectedPricingPlan) {
        selectedPricingPlan.cartQuantity = item.Quantity;
      }
    });
  }
};